var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMagnifier = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B18F541F-C4AA-47AA-987C-A5B869A80A7D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10-predective-search-result",
    transform: "translate(-302.000000, -26.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_magnifier",
    transform: "translate(20.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,10 C19,7.23850269 16.7614421,5 14,5 C11.2379557,5 9,7.23814722 9,10 C9,12.7618528 11.2379557,15 14,15 C16.7614421,15 19,12.7614973 19,10 Z M9.80764196,15.6065716 L3.70710678,21.7071068 L2.29289322,20.2928932 L8.39343257,14.1923539 C7.51829899,13.0237915 7,11.5725007 7,10 C7,6.13361603 10.1333479,3 14,3 C17.8660005,3 21,6.13392214 21,10 C21,13.8660779 17.8660005,17 14,17 C12.42744,17 10.976171,16.4816895 9.80764196,15.6065716 Z",
    id: "shape"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMagnifier);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_magnifier.12202b51a714b7374fcab0c6c0d99e82.svg";